import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useState, ChangeEvent, InputHTMLAttributes } from "react";
import { FormikTouched } from "formik";

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  error?: string;
  touched?: boolean | FormikTouched<any>;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  formatFn?: (value: string) => string;
  isPassword?: boolean;
  min?: number;
  max?: number;
  isPercentage?: boolean;
  width?: string | number;
  isUpperCase?: boolean;
  isLowerCase?: boolean;
}

export default function TextInputField({
  name,
  label,
  maxLength,
  min,
  max,
  setFieldValue,
  formatFn,
  isPassword = false,
  isPercentage = false,
  width,
  isUpperCase = false,
  isLowerCase = false,
  ...props
}: InputFieldProps) {
  const [visiblePassword, setVisiblePassword] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;

    if (isPercentage) {
      inputValue = inputValue.replace(/[^0-9.,]/g, "").replace(",", ".");

      if (!isNaN(Number(inputValue)) || inputValue === "") {
        setFieldValue(name, inputValue);
      }
    } else if (formatFn) {
      inputValue = formatFn(inputValue);
      setFieldValue(name, inputValue);
    } else {
      setFieldValue(name, inputValue);
    }

    if (isPercentage) {
      const inputElement = e.target;
      setTimeout(() => {
        inputElement.setSelectionRange(
          inputElement.value.length - 1,
          inputElement.value.length - 1
        );
      }, 0);
    }
  };

  const getDisplayValue = () => {
    if (props.value === "") return "";
    if (isPercentage && props.value != null && props.value !== "") {
      const numericValue = props.value.toString().replace(".", ",");
      return numericValue.endsWith("%") ? numericValue : `${numericValue}%`;
    }
    return props.value;
  };

  const isInvalid = !!props.error && !!props.touched;

  return (
    <FormControl id={name} isInvalid={isInvalid}>
      {label && <FormLabel style={{ color: isInvalid ? "#E53E3E" : "inherit" }}>{label}</FormLabel>}
      <InputGroup>
        <Input
          type={
            isPassword ? (visiblePassword ? "text" : "password") : props.type
          }
          placeholder={props.placeholder}
          value={getDisplayValue()}
          onChange={handleChange}
          maxLength={maxLength}
          min={min}
          max={max}
          width={width}
          textTransform={isUpperCase ? "uppercase" : isLowerCase ? "lowercase" : "none"}
        />
        {isPassword && (
          <InputRightElement>
            <span onClick={() => setVisiblePassword(!visiblePassword)}>
              {visiblePassword ? (
                <EyeInvisibleOutlined
                  style={{ color: "#CACDD1", cursor: "pointer" }}
                />
              ) : (
                <EyeOutlined style={{ color: "#CACDD1", cursor: "pointer" }} />
              )}
            </span>
          </InputRightElement>
        )}
      </InputGroup>
      <FormErrorMessage fontSize={12} marginTop={1}>
        {props.error}
      </FormErrorMessage>
    </FormControl>
  );
}
